/**
 * Removes query parameters from a URL, preserving the full path including any # characters.
 * This is used to simplify S3 signed URLs by removing signature query parameters.
 * 
 * @param url - The full URL (e.g., "https://bucket.s3.../path/to/file#name.png?X-Amz-Algorithm=...")
 * @returns The URL without query parameters (e.g., "https://bucket.s3.../path/to/file#name.png")
 */
export function simplifyUrl(url: string) {
    return url.split('?')[0];
  }